import { render, staticRenderFns } from "./DarkModeSwitch.vue?vue&type=template&id=390d467d&scoped=true&"
import script from "./DarkModeSwitch.vue?vue&type=script&lang=js&"
export * from "./DarkModeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./DarkModeSwitch.vue?vue&type=style&index=0&id=390d467d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390d467d",
  null
  
)

export default component.exports